module.exports = __webpack_public_path__ + "img/18.f7026527.png";